import Hivue from "./Hivue";
const defaultOptions = {
  xOffset: "0px",
  yOffset: "0px",
  inDelay: 10,
  outDelay: 10,
  durition: 1000,
  ease: "ease-in-out",
  opacity: 1,
  hideInitially: true
};
export default class HiveFader {
  element;
  options;
  timeId;
  currentStat = "in";

  constructor(element, options) {
    this.options = Object.assign({}, defaultOptions, options);
    this.element = Hivue.$el(element);

    const ms = this.options.durition + "ms";
    const originalTransition = Hivue.getComputedStyle(
      this.element,
      "transition"
    );
    const ot = originalTransition.length ? originalTransition + "," : "";
    // Hivue.log(originalTransition);
    const init = {
      transition: ot + "transform " + ms + ",opacity " + ms,
      opacity: this.options.hideInitially ? 0 : this.options.opacity,
      transform:
        "translate(" + this.options.xOffset + "," + this.options.yOffset + ")",
      visibility: this.options.hideInitially ? "hidden" : ""
    };
    Hivue.setStyle(element, init);
    // Hivue.setStyle(element,{visibility:"hidden"});
    // Hivue.log(init);
    this.element.addEventListener("transitionend", e => {
      if (e.target !== this.element) return;
      if (this.currentStat === "out") {
        // Hivue.log("out hidden");
        this.element.style.visibility = "hidden";
        // Hivue.log(this.element);
      }
    });
  }

  in(instant) {
    clearTimeout(this.timeId);
    this.currentStat = "in";
    this.element.style.visibility = "visible";
    this.timeId = setTimeout(
      () => {
        Hivue.setStyle(this.element, {
          opacity: this.options.opacity,
          transform: "translate(0px,0px)"
        });
      },
      instant ? 10 : this.options.inDelay
    );
    // Hivue.log("in");
    // Hivue.log(this.element);
  }
  out(instant) {
    clearTimeout(this.timeId);
    this.currentStat = "out";
    this.timeId = setTimeout(
      () => {
        Hivue.setStyle(this.element, {
          opacity: 0,
          transform:
            "translate(" +
            this.options.xOffset +
            "," +
            this.options.yOffset +
            ")",
          transitionTimingFunction: this.options.ease
        });
      },
      instant ? 10 : this.options.outDelay
    );
  }
  setStyle(styleObj) {
    Hivue.setStyle(this.element, styleObj);
  }
}
